import { createFileRoute } from "@tanstack/react-router";
import { MoneyScreen } from "./-money/MoneyScreen";

export const Route = createFileRoute("/admin/money")({
  staticData: { title: "Money" },
  component: MoneyScreen,
});
